import {$, w} from './constants';

export function topPicksGrid() {

	$('.top_picks_btn_JS').click(function () {
		$('.top_picks_btn_JS').toggleClass('active')
		$('.top_picks_grid_JS').toggleClass('block')
	})

}